import { NgModule } from '@angular/core';
import { AuthService } from './authService';
import {AuthAdminService} from "./authAdminService";
import {CurrentPatientService} from "./currentPatient";
import {EmailService} from "./email.service";
import {AcknowledgmentsService} from "./acknowledgments.service";
import {BiblioService} from "./biblio.service";
import {UsageService} from "./usage.service";

@NgModule({
    providers: [
      AuthAdminService,
      AuthService,
      CurrentPatientService,
      EmailService,
      AcknowledgmentsService,
      BiblioService,
      UsageService
    ],
})
export class ServicesModule { }




// WEBPACK FOOTER //
// ./src/services/services.module.ts